import { CommonAction } from '../../../message/redux/types';
import ConstantsTypes, { Constants } from './types';

function setConstants(data: Constants): CommonAction {
    return {
        type: ConstantsTypes.SET_CONSTANTS,
        payload: data,
    };
}

function fetchConstants(): CommonAction {
    return {
        type: ConstantsTypes.FETCH_CONSTANTS,
        payload: undefined,
    };
}

const constantsActions = {
    setConstants,
    fetchConstants,
};

export default constantsActions;
